import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { REACT_APP_CLOUD_FRONT } from "../../../constants";
import {
  IOfferItem,
} from "../../../models/cart.model";
import styleClasses from "../../Header/Header.module.scss";
import { useAppSelector } from "../../../redux/store/store";
import useRedeemOffer from "../../../hooks/useRedeemOffer";
import OfferEligibilityModal from "./OfferEligibilityModal";
import { useLocation } from "react-router-dom";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";

interface IOfferItemCardProps {
  offerItem: IOfferItem;
  selectedOfferItem: IOfferItem;
  handleRedeemClick: () => void;
  btnText: string;
  rewardsDiscountedSubTotal: number;
  isDisabled?:boolean;
}

const OfferItemCard: React.FC<IOfferItemCardProps> = ({
  offerItem,
  selectedOfferItem,
  btnText,
  rewardsDiscountedSubTotal,
  isDisabled
}) => {
  const {
    name,
    image_url,
    in_cart,
    redirect_item_id,
  } = offerItem;
  const [offerEligibilityModal, setOfferEligibilityModal] = useState<{
    show: boolean;
    failedOfferCriteria: string;
    redeemedItemNames: string[];
  }>({
    show: false,
    failedOfferCriteria: "",
    redeemedItemNames: [],
  });
  const location = useLocation();
  const isItMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  const cartItems = useAppSelector((state) => state.cart.items);
  const { redeemOffer } = useRedeemOffer();
  const redeemOfferItem = () => {
    const { shouldShowOfferEligibilityModal, failedOfferCriteria, redeemedItemNames } =
      redeemOffer({
        offerItem,
        cartItems,
        selectedOfferItem,
        rewardsDiscountedSubTotal,
        isOfferClicked: true,
      });
    if (shouldShowOfferEligibilityModal) {
      setOfferEligibilityModal({show: true, failedOfferCriteria, redeemedItemNames});
    }
  };

  return (
    <>
      <OfferEligibilityModal 
        show={offerEligibilityModal.show}
        offerFailedCriteria={offerEligibilityModal.failedOfferCriteria}
        redeemedItemNames={offerEligibilityModal.redeemedItemNames}
        offerDetails={offerItem.data}
        closeModal={() => setOfferEligibilityModal({show: false, failedOfferCriteria: "", redeemedItemNames: []})}
      />
      <Col sm="4" xs="4" className={`${styleClasses.suggestion_column} ${isDesignV2 ? styleClasses.suggestion_column_mobile_designv2 : ''}`}>
        <div
          className={`${styleClasses.other_products_item} text-center ${
            btnText === "Redeemed" && styleClasses.active
          } ${isDisabled && styleClasses.disabled}`}
          data-testid={`offer-${name}`}
        >
           <div className={styleClasses.cart_img_wrap + ' mb-3'}>
            <img
              src={
                image_url
                  ? image_url
                  : `${REACT_APP_CLOUD_FRONT}/Items/${redirect_item_id}/item-${redirect_item_id}.webp`
              }
              className="img-fluid"
              alt={name}
            />
          </div>
          <h5
            className={` lh-18  ${isDesignV2 ? 'f-s15 ls-05 font-Visby-cf f-w5' : 'font-rale f-w5 f-s14 f-sm-s11'}`}
          >
            {name}
          </h5>
          <button
            type="button"
            className={
              styleClasses.pro_item_btn +
              ` btn-large item-select-btn btn h-auto mb-2 text-capitalize mw-auto w-100 px-2 mx-md-2 ${
                !in_cart && "outline"
              } ${isDesignV2 ? `${styleClasses.pro_item_btn_mobile_designv2} font-Visby-cf f-s15 mt-1 py-0` : 'py-1 lh-lg font-rale f-s12'}`
            }
            onClick={() => {
              redeemOfferItem();
            }}
            disabled={isDisabled}
          >
            {btnText}
          </button>
        </div>
      </Col>
    </>
  );
};

export default OfferItemCard;
